import type { FC } from 'react'
import { Button, Input } from 'components/ui'
import { useForm } from 'react-hook-form'
import cn from 'classnames'
import type { Coupon } from 'framework/cart'
import { useCart } from 'hooks'
import s from './cart-coupon.module.css'
import type { CartCouponProps } from '.'

const CartCoupon: FC<CartCouponProps> = ({ className = '' }) => {
  const { setCoupon, metadata, updateCartMetadata } = useCart()

  const {
    register,
    handleSubmit,
    formState: { errors, touched, isSubmitting },
  } = useForm({
    mode: 'onChange',
  })

  const onSubmit = ({ coupon }: { coupon: string }) => {
    const couponProps: Coupon = { id: 'test-coupon', value: 10, description: `Cupom ${coupon}`, type: 'monetary' }
    setCoupon(couponProps)
    updateCartMetadata({ ...metadata, coupon: couponProps as Coupon })
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} className={cn(s.root, className)}>
      <Input
        type="text"
        name="coupon"
        placeholder="Digite aqui seu cupom"
        error={errors.coupon?.message}
        touched={touched?.coupon}
        maxLength={15}
        ref={register({
          required: {
            value: true,
            message: 'Preencha com o cupom desejado',
          },
        })}
      />
      <Button variant="primary" type="submit" loading={isSubmitting} disabled={isSubmitting}>
        Aplicar
      </Button>
    </form>
  )
}

export default CartCoupon
